import React from "react";
import Header from "./mobileComp/Header/Header.js";
import Home from "./mobileComp/Home/Home.js";
import Footer from "./mobileComp/Footer/Footer.js";
import Placeholder from "./mobileComp/About/Placeholder";
import Menu from "./mobileComp/Menu/Menu.js";
import { Switch, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Contact from "./mobileComp/Contact/Contact.js";

export default function Mobile() {
  let location = useLocation();
  return (
    <div>
      <div style={{ minHeight: "calc(100vh - 95px)" }}>
        <Header />
        <TransitionGroup>
          <CSSTransition key={location.key} classNames="fade" timeout={500}>
            <Switch>
              <Route exact path="/" children={<Home />}></Route>
              <Route exact path="/about" children={<Placeholder />}></Route>
              <Route exact path="/menu" children={<Menu />}></Route>
              <Route exact path="/contact" children={<Contact />}></Route>
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      </div>
      <Footer />
    </div>
  );
}
